import { useCallback } from 'react';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import EmMarketIssueTile from '@/creditflowresearch/ui/components/deals/DealTiles/CorporateMarketIssueTile/EmMarketIssueTile';
import DealStatusContextProvider from '@/creditflowresearch/application/Deal/contexts/DealStatusContext';
import DealRepository from '@/creditflowresearch/infrastructure/repository/DealRepository';
import ProductsContextProvider from '@/creditflowresearch/application/Deal/contexts/ProductsContext';
import { getContainer } from '@framework/di/getContainer';
import { DealTooltipProvider } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import CorporateMarketPageContext, { ICorporateMarketPageDealsCollection } from '@/creditflowresearch/application/Deal/contexts/IssueTile/CorporateMarketPageContext';
import { IMarketPagePayload } from '@/creditflowresearch/application/Deal/types';
import { HycProduct, IgcProduct } from '@/creditflowresearch/domain/Product';

export default () => {
  const { deals } = useParentPageContext();
  const container = getContainer();
  const dealRepository = container.get<DealRepository>(DealRepository);
  const fetchDeals = useCallback(
    (payload: IMarketPagePayload) => dealRepository.getCfrCorporateDeals(payload),
    [dealRepository],
  ) as unknown as (payload: IMarketPagePayload) => Promise<ICorporateMarketPageDealsCollection>;
  return (
    <DealStatusContextProvider filters={ deals?.pageFilters?.filters }>
      <ProductsContextProvider availableProductIds={ [HycProduct.PRODUCT_ID, IgcProduct.PRODUCT_ID] }>
        <DealTooltipProvider>
          <CorporateMarketPageContext
            deals={ deals as ICorporateMarketPageDealsCollection }
            fetch={ fetchDeals }
          >
            <EmMarketIssueTile defaultExpandedRowIndexes={ [0] } />
          </CorporateMarketPageContext>
        </DealTooltipProvider>
      </ProductsContextProvider>
    </DealStatusContextProvider>
  );
};
